import React from 'react'

import { Link, useHistory } from 'react-router-dom'
import { RHFInput } from 'react-hook-form-input'
import useForm from 'react-hook-form'

import { Box, Typography, TextField } from '@material-ui/core'

import { Alert } from '@material-ui/lab'

import { routes } from 'routes'
import { Footer } from './components'
import schemas from './schemas'
import PaymentMethodsContext from 'contexts/PaymentMethodsContext'
import integrationToken from 'images/paymentMethodsConfiguration/integrationToken.png'

const PaymentMethodsIntegrationToken = () => {
  const history = useHistory()
  const context = React.useContext(PaymentMethodsContext)
  const { register, setValue, handleSubmit, errors } = useForm({
    validationSchema: schemas.integrationTokenSchema,
    defaultValues: { ...context.data.integrationToken },
  })

  const onSubmit = dataForm => {
    context.setData(data => ({
      ...data,
      integrationToken: { ...data.integrationToken, ...dataForm },
    }))

    history.push(routes.settings.paymentMethods.steps.selectMethods)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box display="flex">
        <Box width={{ xs: '100%', sm: 3 / 5 }} mb={2}>
          <Box mb={2}>
            <Typography color="textSecondary">
              Primeiro, informe seu{' '}
              <Box component="span" fontWeight="fontWeightMedium">
                token de integração Yapay
              </Box>
              .
            </Typography>

            <br />

            <Typography color="textSecondary">
              Ele está disponível na página “Minha conta” do Intermediador,
              junto com os seus dados pessoais, conforme imagem abaixo.
            </Typography>
          </Box>

          <Box display={{ xs: 'block', sm: 'none' }} mb={2} p={4}>
            <Box width="100%" component="img" src={integrationToken} />
          </Box>

          <Box display={{ xs: 'block', sm: 'none' }} mb={4}>
            <Alert severity="info">
              Para acesso ao token, é necessário ter realizado a verificação de
              conta.
            </Alert>
          </Box>

          <Box mb={4}>
            <RHFInput
              as={
                <TextField
                  name="integrationToken"
                  label="Token de integração"
                  error={!!errors?.integrationToken}
                  helperText={errors?.integrationToken?.message}
                  fullWidth
                />
              }
              name="integrationToken"
              register={register}
              setValue={setValue}
              mode="onChange"
            />
          </Box>

          <Box display={{ xs: 'none', sm: 'block' }}>
            <Alert severity="info">
              Para acesso ao token, é necessário ter realizado a verificação de
              conta.
            </Alert>
          </Box>
        </Box>

        <Box
          display={{ xs: 'none', sm: 'block' }}
          width={2 / 5}
          mb={2}
          p={{ sm: 4, lg: 6 }}
        >
          <Box width="100%" component="img" src={integrationToken} />
        </Box>
      </Box>

      <Footer
        prevButtonProps={{ component: Link, to: routes.settings.all }}
        nextButtonProps={{ type: 'submit' }}
      />
    </form>
  )
}

export default PaymentMethodsIntegrationToken
